var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgArrows = function SvgArrows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 29,
    viewBox: "0 0 12 29",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7504 7.03033C12.0433 6.73744 12.0433 6.26256 11.7504 5.96967L6.97745 1.1967C6.68456 0.903806 6.20968 0.903806 5.91679 1.1967C5.6239 1.48959 5.6239 1.96447 5.91679 2.25736L10.1594 6.5L5.91679 10.7426C5.6239 11.0355 5.6239 11.5104 5.91679 11.8033C6.20968 12.0962 6.68456 12.0962 6.97745 11.8033L11.7504 7.03033ZM0.779785 7.25L11.2201 7.25V5.75L0.779785 5.75V7.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.249579 22.4697C-0.0433149 22.7626 -0.043315 23.2374 0.249578 23.5303L5.02255 28.3033C5.31544 28.5962 5.79032 28.5962 6.08321 28.3033C6.3761 28.0104 6.3761 27.5355 6.08321 27.2426L1.84057 23L6.08321 18.7574C6.3761 18.4645 6.3761 17.9896 6.08321 17.6967C5.79032 17.4038 5.31544 17.4038 5.02255 17.6967L0.249579 22.4697ZM11.2202 22.25L0.779908 22.25L0.779908 23.75L11.2202 23.75L11.2202 22.25Z",
    fill: "white"
  })));
};

export default __webpack_public_path__ + "static/media/arrows.a2434d61.svg";
export { SvgArrows as ReactComponent };